import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { initConsent } from "../lib/consent";

// Injects Google Analytics 4 (gtag) and Google Tag Manager programmatically
// (reliable for executable scripts), and the Search Console verification meta
// via Helmet. All IDs are public by design and come from admin settings.
function addScript(id, src) {
  if (document.getElementById(id)) return;
  const s = document.createElement("script");
  s.id = id;
  s.async = true;
  s.src = src;
  document.head.appendChild(s);
}

export default function Analytics({ ga4, gsc }) {
  // Consent Mode v2: apply any prior stored choice (default 'denied' is set in index.html before GTM loads).
  useEffect(() => { initConsent(); }, []);

  useEffect(() => {
    if (!ga4) return;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    addScript("ga4-src", `https://www.googletagmanager.com/gtag/js?id=${ga4}`);
    window.gtag("js", new Date());
    window.gtag("config", ga4);
  }, [ga4]);

  if (!gsc) return null;
  return (
    <Helmet>
      <meta name="google-site-verification" content={gsc} />
    </Helmet>
  );
}
